import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Box, Flex } from '@change-corgi/design-system-legacy/layout';

import { Html } from 'src/app/shared/components/html';

import { Label } from '../Label';

import { labelContainerStyles, messageContainerStyles, messageTextStyles } from './styles';

type Props = PropsWithChildren<{
	qaSelectorLabel: string;
	qaSelectorMessage: string;
	label: string;
	message: string;
}>;

export const RadioLabel: React.FC<Props> = ({ qaSelectorLabel, qaSelectorMessage, label, message, children }) => {
	return (
		<Box sx={labelContainerStyles}>
			<Label qaSelectorLabel={qaSelectorLabel} label={label} />
			<Flex sx={messageContainerStyles}>
				<Html as="span" html={message} data-qa={qaSelectorMessage} sx={messageTextStyles} />
				{children}
			</Flex>
		</Box>
	);
};
